import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	cardAmount: {
		id: 'backlog.card-list.card-list-header.card-amount',
		defaultMessage: '{cardAmount} {cardAmount, plural, one {issue} other {issues}}',
		description: '',
	},
	visibleCardAmount: {
		id: 'backlog.card-list.card-list-header.visible-card-amount',
		defaultMessage:
			'{cardAmount} of {totalCardAmount} {totalCardAmount, plural, one {issue} other {issues}} visible',
		description: '',
	},
	startSprint: {
		id: 'backlog.card-list.card-list-header.start-sprint',
		defaultMessage: 'Start sprint',
		description: '',
	},
	createSprint: {
		id: 'backlog.card-list.card-list-header.create-sprint',
		defaultMessage: 'Create sprint',
		description: 'Create sprint button on the next-gen backlog',
	},
	completeSprint: {
		id: 'backlog.card-list.card-list-header.complete-sprint',
		defaultMessage: 'Complete sprint',
		description: 'Complete sprint button text',
	},
	disabledStartSprintButtonEmpty: {
		id: 'backlog.card-list.card-list-header.disabled-start-sprint-button-empty',
		defaultMessage: 'Sprint cannot be started because it contains no issues',
		description: '',
	},
	disabledStartSprintButtonNoParallel: {
		id: 'backlog.card-list.card-list-header.disabled-start-sprint-button-no-parallel',
		defaultMessage: 'Can be planned but not started until the completion of above active sprint',
		description: '',
	},
	sprintListNamePrefix: {
		id: 'backlog.card-list.card-list-header.sprint-list-name-prefix',
		defaultMessage: 'sprint',
		description: '',
	},
	expandAccessabilityLabel: {
		id: 'backlog.card-list.card-list-header.expand-accessability-label',
		defaultMessage: 'Expand',
		description: '',
	},
	collapseAccessabilityLabel: {
		id: 'backlog.card-list.card-list-header.collapse-accessability-label',
		defaultMessage: 'Collapse',
		description: '',
	},
	createSprintButtonDisabledInfoTextNonFinal: {
		id: 'backlog.card-list.card-list-header.create-sprint-button-disabled-info-text-non-final',
		defaultMessage: 'Request permissions from project admin',
		description:
			'Text to display when the create sprint button is disabled due to lack of permissions',
	},
	completeSprintButtonDisabledInfoTextNonFinal: {
		id: 'backlog.card-list.card-list-header.complete-sprint-button-disabled-info-text-non-final',
		defaultMessage: 'Request permissions from project admin',
		description:
			'Text to display when the complete sprint button is disabled due to lack of permissions',
	},
});
